import React from "react";
import styled from "styled-components";
import { darken } from "polished";
import placeholderCardImage from "./placeholderCardImage.png";
import { Typography } from "../Typography";
import { Spinner } from "../Spinner";
import { Search } from "../Icons";
import { Tooltip } from "../Tooltip";

export interface FlagProps extends React.HTMLAttributes<HTMLDivElement> {
    state?: boolean;
    text?: string;
}
export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string;
    subtitle: string;
    description?: string;
    image?: string;
    onClick?: (...args: any) => void;
    extra?: React.ReactNode;
    loading?: boolean;
    children?: any;
    content?: React.ReactNode;
    flag?: FlagProps;
}
export interface CardImageProps extends React.HTMLAttributes<HTMLDivElement> {
    backgroundImage?: string;
}
export interface CardFlagProps extends React.HTMLAttributes<HTMLDivElement> {
    flag?: boolean;
    text?: string;
}
export interface CardHoverImageProps
    extends React.HTMLAttributes<HTMLDivElement> {
    loading?: boolean;
}

const trimText = (text: string, maxLength = 75) => {
    const output =
        text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    return output;
};

const placeholderImg =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLAAAAKYCAYAAABjDgGuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODc4NkRFNjlBRjlEMTFFOUFEODBBMTlFNDk2N0Q3MUYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODc4NkRFNkFBRjlEMTFFOUFEODBBMTlFNDk2N0Q3MUYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4Nzg2REU2N0FGOUQxMUU5QUQ4MEExOUU0OTY3RDcxRiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4Nzg2REU2OEFGOUQxMUU5QUQ4MEExOUU0OTY3RDcxRiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PkHMCywAABJFSURBVHja7NgxAQAgAMMwwL/nYaNHIqFn77YDAAAAAFVPAgAAAADKDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANK+AAMAT78ILQqD1eEAAAAASUVORK5CYII=";

const Card = ({
    title,
    subtitle,
    description = "",
    image,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick = () => {},
    extra,
    content,
    loading = false,
    flag = { state: false, text: "" },
}: CardProps) => {
    const imgSrc = image || (placeholderCardImage as string);

    const trimDescription = trimText(description);

    const wrappedTitle = (
        <Typography
            variant="h3"
            color="primary"
            noWrap={true}
            onClick={onClick}
        >
            {title}
        </Typography>
    );

    const TitleWithTooltipIfNeeded =
        title.length > 21 ? (
            <Tooltip text={title} position="top">
                {wrappedTitle}
            </Tooltip>
        ) : (
            wrappedTitle
        );

    return (
        <StyledCard flag={flag.state} text={flag.text}>
            {loading ? (
                <StyledCardImage backgroundImage={imgSrc}>
                    <img src={placeholderImg} />
                    <StyledCardHoverImage loading={loading}>
                        <Spinner />
                    </StyledCardHoverImage>
                </StyledCardImage>
            ) : (
                <>
                    <StyledCardImage backgroundImage={imgSrc} onClick={onClick}>
                        <img src={placeholderImg} />
                        <StyledCardHoverImage>
                            <StyledCardHoverImageIcon>
                                {content ? (
                                    content
                                ) : (
                                    <button
                                        className="icon"
                                        type="button"
                                        onClick={onClick}
                                    >
                                        <Search size="15%" color="white" />
                                    </button>
                                )}
                            </StyledCardHoverImageIcon>
                            <StyledCardHoverImageText>
                                {trimDescription}
                            </StyledCardHoverImageText>
                        </StyledCardHoverImage>
                    </StyledCardImage>
                </>
            )}

            <StyledCardBottomContainer>
                <StyledCardInfoContainer>
                    {TitleWithTooltipIfNeeded}
                    <Typography variant="p" noWrap={true} title={subtitle}>
                        {subtitle}
                    </Typography>
                </StyledCardInfoContainer>

                <StyledCardOptions>{extra}</StyledCardOptions>
            </StyledCardBottomContainer>
        </StyledCard>
    );
};

const StyledCard = styled.div<CardFlagProps>`
    position: relative;
    width: 100%;
    overflow: initial;
    background-color: ${({ theme }) => theme.colors.grey50};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    ${(props) =>
        props.flag === true &&
        `
        &:after{
            content: "${props.text}";
            position: absolute;
            right: -8px;
            top: 12px;
            background-color: ${props.theme.colors.tertiary};
            padding: 2px 12px;
            color: ${props.theme.colors.white};
            min-height: 28px;
            max-height: 28px;
        }
        &:before{
            content: " ";
            position: absolute;
            right: -8px;
            top: 40px;
            width: 0;
            height: 0;
            border-left: 0px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid ${darken(0.1, props.theme.colors.tertiary)};
        }
    `}
`;

const StyledCardImage = styled.div<CardImageProps>`
    position: relative;
    width: 100%;
    max-height: 230px;
    display: block;
    overflow: hidden;
    background-image: url(${(props) => props.backgroundImage});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    > img {
        object-fit: cover;
        overflow: hidden;
    }
    ${(props) =>
        props.onClick &&
        `
        &:hover {
            cursor: pointer;
        }
    `};
`;

const StyledCardHoverImage = styled.div<CardHoverImageProps>`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    transition: 0.25s;
    ${(props) =>
        props.loading === true &&
        `
        background-color: ${props.theme.colors.grey100};
        opacity: 1;
    `}

    &:hover {
        opacity: 1;
        transition: 0.25s;
    }
`;

const StyledCardHoverImageIcon = styled.div`
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    display: grid;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 8px;
    align-items: center;

    button > svg {
        justify-self: center;
        &:hover {
            cursor: pointer;
        }
    }
    > button {
        font-weight: ${({ theme }) => theme.typography.weight.bold};
        border: none;
        border-radius: 4px;
        padding: 2px 20px;
        outline: none;
        &:first-child {
            background-color: rgba(255, 255, 255, 0.3);
            color: ${({ theme }) => theme.colors.white};
        }
        &:not(:only-child):last-child {
            background-color: ${({ theme }) => theme.colors.white};
            color: ${({ theme }) => theme.colors.primary};
        }
        &.icon {
            background-color: transparent;
        }
        &:hover {
            cursor: pointer;
        }
    }
    &::-webkit-scrollbar {
        display: none;
    }
`;

const StyledCardHoverImageText = styled.div`
    display: flex;
    align-self: flex-end;
    align-content: center;
    justify-content: center;
    margin-bottom: 10px;
    color: white;
    max-height: 22%;
    text-align: center;
    width: 90%;
    line-height: 19px;
`;

const StyledCardBottomContainer = styled.div`
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: space-between;
    background-color: white;
    padding: 15px 0px 15px 20px;
    overflow: hidden;
`;

const StyledCardInfoContainer = styled.div`
    width: 75%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    h3 {
        cursor: pointer;
    }

    p {
        color: ${({ theme }) => theme.colors.grey700};
        font-size: ${({ theme }) => theme.typography.text.small};
    }
`;

const StyledCardOptions = styled.div`
    width: 40px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    svg {
        height: 25px;
    }
`;

export default Card;
